const LIST_URL = "/v1/warehouse/list";

const WAREHOUSE_API_URL_LIST = {
    LIST_URL
}

export { WAREHOUSE_API_URL_LIST };